import React from "react";
import Preloader from "../helper/Preloader";
import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
  import ScrollToTop from "react-scroll-to-top";
 import FooterOne from "../components/FooterOne";
 import TopupWalletViewAmazon from "../componentsAmazon/TopupWalletViewAmazon";
import HeaderFooterInit from "../componentsAmazon/HeaderFooterInit";
   

const TopUpAmazon = () => {



  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

     {/* HeaderFooterInit  */}
     <HeaderFooterInit/>

      {/* TopUp */}
      <TopupWalletViewAmazon />
 

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default TopUpAmazon;
